import { Fragment } from 'react'
import type { ReactElement } from 'react'
import styled from 'styled-components'

import { cpMapList } from './CPMapList'
import { MapCard } from './MapCard'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { CompanyLinks } from '@/components/layouts/Company/CompanyLinks'
import { Head } from '@/components/layouts/Head'

const sectionTitle = {
  titleText: 'Access',
  subTitleText: 'アクセス',
}

export const AccessPage = () => {
  return (
    <>
      <Head
        title={sectionTitle.subTitleText}
        description="トライアルホールディングスのオフィスへのアクセスを掲載しています。"
        ogp={{ type: 'article', url: 'company/access/' }}
      />
      <AccessContainer>
        <Spacer h={{ sp: 40, pc: 69 }} />
        <SectionTitle
          color="normal"
          titleText={sectionTitle.titleText}
          subTitleText={sectionTitle.subTitleText}
        />
        <Spacer h={{ sp: 58, pc: 129 }} />
        {cpMapList.map((value, index) => (
          <Fragment key={value.addressUrl}>
            <MapCard {...value} />
            {index !== cpMapList.length - 1 && (
              <Spacer h={{ sp: 41, pc: 76 }} />
            )}
          </Fragment>
        ))}
        <CompanyLinks padding={{ pc: '130px 0 0' }} />
      </AccessContainer>
    </>
  )
}
AccessPage.getLayout = function getLayout(page: ReactElement) {
  const pageTitle = {
    title: 'Corporate Information',
    subTitle: '企業情報',
  }

  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '企業情報', path: '/company/' },
    { name: 'アクセス', path: '' },
  ]

  return (
    <TitleLayout {...pageTitle} breadCrumbs={breadCrumbs} isRequiredBackground>
      {page}
    </TitleLayout>
  )
}

const AccessContainer = styled.div`
  width: 1040px;
  padding-bottom: 130px;
  margin: 0 auto;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 0px 20px 75px;
  }
`
